<z-pages-container
  [navigationList]="navigationList"
  [dashboardRoutes]="dashboardRoutes"
  [settingsRoutes]="settingRoutes[0]"
  [configurations]="configurations"
  [tools]="appTools()"
  [regions]="regions()"
  [locations]="locations()"
  [(selectedLocations)]="selectedLocations"
  [(selectedRegions)]="selectedRegions"
  (selectedLocationsChange)="selectedLocationChange($event)"
  (selectedRegionsChange)="selectedRegionChange($event)"
>
  @if (!isStandalonePortal()) {
    <div ngProjectAs="notification-section-template">
      <div class="notification-section-template-sample flex align-items-center">
        <button
          type="button"
          class="cursor-pointer"
          (click)="openMessagesDrawer()"
        >
          <em class="ph-fill ph-chats-circle"></em>
        </button>
        <button
          type="button"
          class="cursor-pointer"
          (click)="openNotificationsDrawer()"
        >
          <em class="ph ph-bell"></em>
        </button>
      </div>
    </div>
  }
  <div
    ngProjectAs="page-content"
    class="h-full overflow-auto main-router-outlet"
  >
    <router-outlet />
  </div>
</z-pages-container>

<z-about-dialog
  [isAboutDialogVisible]="isAboutDialogVisible()"
  (isAboutDialogVisibleChange)="isAboutDialogVisible.set($event)"
/>
